module.exports = __webpack_public_path__ + "static/07-ffedf911f8597e9bf38cfbf7c338f344.jpg";